import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import appConstants from "../constants/appConstants";
import { useNavigate } from "react-router-dom";
import { useAppContext  } from "../context/AppContext";

const Settings = () => {
  const { institute, setInstitute } = useAppContext ();
  const navigate = useNavigate();
  const [thisInstitute, setThisInstitute] = useState({
    name: "",
    code: "",
    address: "",
    mobile: "",
    email: "",
    website: "",
    demo: 0,
    curr_name: "",
    curr_short_name: "",
    curr_basic_name: "",
    curr_basic_short_name: "",
    decimal_point: 2,
    round_off: "No",
    academic_year_start: "",
    receipt_vno_start: 1,
    payment_vno_start: 1,
    journal_vno_start: 1,
    contra_vno_start: 1,
  });

  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    fetchInstituteDetails();
  }, []);

  const fetchInstituteDetails = async () => {
    setLoading(true);
    setError("");
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await fetch(`${appConstants.API_ROOT_URL}get-my-institute`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        setThisInstitute(data.data);
        setInstitute(data.data);
      } else {
        setError(data.message || "Failed to fetch institute details.");
      }
    } catch (error) {
      setError("Network error. Please try again." + error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setThisInstitute({ ...thisInstitute, [e.target.name]: e.target.value });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setUpdating(true);
    setError("");
    setSuccess("");
  
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await fetch(`${appConstants.API_ROOT_URL}update-institute`, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(thisInstitute),
      });
  
      const data = await response.json();
      if (response.ok) {
        setSuccess("Institute details updated successfully!");
        await fetchInstituteDetails();
      } else {
        setError(data.message || "Failed to update institute details.");
      }
    } catch (error) {
      setError("Network error. Please try again.");
    } finally {
      setUpdating(false);
    }
  };
  
  return (
    <Layout>
      <h2 className="text-center">Institute Settings</h2>

      {loading && <div className="alert alert-info text-center">Loading...</div>}
      {error && <div className="alert alert-danger text-center">{error}</div>}
      {success && <div className="alert alert-success text-center">{success}</div>}

      {!loading && (
        <div className="card p-4" style={{ maxWidth: "600px", margin: "auto" }}>
          <form onSubmit={handleUpdate}>
          {Object.keys(thisInstitute)
            .filter((key) => !["id", "demo", "status"].includes(key)) // Ignore specific keys
            .map((key) => (
              <div className="mb-3" key={key}>
                <label className="form-label">{key.replace(/_/g, " ").toUpperCase()}</label>
                <input
                  type={typeof thisInstitute[key] === "number" ? "number" : "text"}
                  className="form-control"
                  name={key}
                  value={thisInstitute[key]}
                  onChange={handleChange}
                  disabled={key === "code"}
                />
              </div>
            ))}


            <button type="submit" className="btn btn-primary w-100" disabled={updating}>
              {updating ? "Updating..." : "Update"}
            </button>
          </form>
        </div>
      )}
    </Layout>
  );
};

export default Settings;
